import { Star, ChevronDown } from "lucide-react";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

const ReviewsTab = ({ reviews, updateStatus }) => (
  <div className="bg-white border border-[#E6E4DD]">
    <div className="p-6 border-b border-[#E6E4DD]"><h2 className="font-medium text-[#1C1C1A]">Customer Reviews</h2></div>
    <div className="overflow-x-auto">
      <table className="admin-table">
        <thead><tr><th>Customer</th><th>Rating</th><th>Review</th><th>Status</th><th>Actions</th></tr></thead>
        <tbody>
          {reviews.map(r => (
            <tr key={r.id}>
              <td><p className="font-medium">{r.customer_name}</p>{r.company && <p className="text-xs text-[#6B6A65]">{r.company}</p>}</td>
              <td><div className="flex">{[...Array(5)].map((_, i) => <Star key={i} size={14} className={i < r.rating ? "fill-yellow-400 text-yellow-400" : "text-gray-300"} />)}</div></td>
              <td className="max-w-xs"><p className="text-sm text-[#6B6A65] line-clamp-2">{r.review_text}</p></td>
              <td><span className={`px-2 py-1 text-xs ${r.status === 'approved' ? 'bg-green-100 text-green-800' : r.status === 'rejected' ? 'bg-red-100 text-red-800' : 'bg-yellow-100 text-yellow-800'}`}>{r.status}</span></td>
              <td>
                <DropdownMenu>
                  <DropdownMenuTrigger className="p-2 hover:bg-[#F7F5F0]"><ChevronDown size={16} /></DropdownMenuTrigger>
                  <DropdownMenuContent>
                    <DropdownMenuItem onClick={() => updateStatus('reviews', r.id, 'approved')}>Approve</DropdownMenuItem>
                    <DropdownMenuItem onClick={() => updateStatus('reviews', r.id, 'rejected')}>Reject</DropdownMenuItem>
                  </DropdownMenuContent>
                </DropdownMenu>
              </td>
            </tr>
          ))}
          {reviews.length === 0 && <tr><td colSpan={5} className="text-center py-12 text-[#6B6A65]">No reviews yet.</td></tr>}
        </tbody>
      </table>
    </div>
  </div>
);

export default ReviewsTab;
